<template>
  <div class="cuotiben_Warp">
     <div class="topAll"> 
    <div class="top1"
         @click='toCollect'>
      我的收藏
    </div>
    <div style="display:flex;gap:8rem;">
    <div class="top3"
         v-if="showCheck"
         @click="allSelect">全选
    </div>

    <div class="top2"
         @click='exportError(1,0)'>
      导出错题
    </div>
       <div class="top2"
         @click='wrongPaper'>
      生成试卷
    </div>
    <div class="top">
      <div class="del"
           v-if="!showCheck"
           @click="del">删除</div>
      <div class="del"
           v-else
           @click="del">删除</div>

    </div>
    </div>
 </div>
    <COMMONTOPSEARCH ref="commonTopSearchRef"
                     @initData="getPaperList"
                     @showSearch="showSearch"
                      
                     :url="'/api/v1/my/wrong_question_subject'"
                     :isDefault="false"
                     :showBack="false"
                     :isDefaultDialog="false"
                     :showTag="showTag" />

    <div class="topic_warp" v-if="paperList.length>0">
      <div class="topic_item_wrap"
           v-for="(item,index) in paperList"
           :key="index">
        <div class="topic" @click="toInfo1(item)"
              >
          <div class="checked"
               :style="{'border':  checkIds.indexOf(item.user_paper_detail_id) != -1 ?'none':''}"
               v-if="showCheck" @click.stop="toInfo(item,1)">
            <img src="@/static/cuotiben/chcked.png"
                 style="transform: rotate(16deg);"
                 v-if="checkIds.indexOf(item.user_paper_detail_id) != -1"
                 alt="">
          </div>
          <div class="question_type"><span>{{item.question_type_name}}</span></div>
          <div class="pre_content"><span style="color:#999">题目内容:</span>{{ contentHtml(item.question_content)}}</div>
          <div class="comment"><span style="color:#999">笔记:</span>{{item.comment_to_user || '无'}}</div>

          <!-- <div class="btn"
               @click="toInfo1(item)">
            查看详情

          </div> -->

          <div class="time">
            {{item.paper_time}}
          </div>
          <div style="position: absolute;right: 7rem;bottom: 10rem;"
               @click.stop="del1(item.user_paper_detail_id)">
            <img src="@/static/Trash.png"
                 style="width: 32rem;height: 32rem;"
                 alt="">
          </div>

        </div>
      </div>
      <!-- 布局占位 -->
      <div class="topic_item_wrap"
           style="height:0"></div>
      <div class="topic_item_wrap"
           style="height:0"></div>
    </div>
     <div v-else
         class="its"
         > 暂无数据</div>
    <div style="text-align:center;margin-top:40rem">
      <Apagination :total="totalElement"
                   :defaultInit="false"
                   
                   :nowPage="myPage"
                   v-show="totalElement>0"
                   @initData="initData" />
    </div>
    <Search ref="searchRef"
            @getData='initData' />
    <Check ref="checkRef"
           @exportData='exportError' />
           <div class="autoModal"
         v-if="autoModalFlag">
      <div class="openButton">

        <a-button type="warning"
                   @click="toBuy"
                   class="btntext"><span class="text">开通VIP享受全部功能</span></a-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import COMMONTOPSEARCH from '@/views/components/COMMON_TOP_SEARCH/index.vue'
import { ref } from '@vue/reactivity'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import { getErrorList, delError, errorTopicType, exportWrongPrint } from '@/api/errorBook.js'
import { message, Modal } from 'ant-design-vue'
import Search from './components/search.vue'
import { nextTick, onMounted } from '@vue/runtime-core'
import Check from './components/check.vue'

const route = useRoute()
const router = useRouter()

const commonTopSearchRef = ref(null)
let paginationRef = ref()
let showTag = ref(true)
let paperList = ref([])
let checkIds = ref('')
let questionIds = ref([])
let showCheck = ref(false)
let autoModalFlag = ref(false)
let subject_id = ref('')
let totalElement = ref(0)
let keyword = ref('')
let myPage = ref(1)
let mySize = ref(9)
let form = ref({})
let sessionData = ref()

const contentHtml = (content) => {
  // 富文本编辑器的内容只获得文字去掉标签
  content = content.replace(/<[^>]+>/g, "").replace(/&nbsp;/ig, "").replace(/(\n)/g, "");
  return content
}
const setSessionData = (params) => {
  window.sessionStorage.setItem(route.path, JSON.stringify(params))
}
const getSessionData = () => {
  if (window.sessionStorage.getItem(route.path)) {
    sessionData.value = JSON.parse(window.sessionStorage.getItem(route.path))
  }
}
const toBuy = () => {
  router.push('/buyVip')
}


onBeforeRouteLeave((to, from, next) => {
  if (to.path != '/errorBook/errorInfo') {
    window.sessionStorage.removeItem(route.path)
  }
  next()
})


onMounted(() => {
  getSessionData()
  del()
   let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    if (userInfo.user_type_id == 101 && !userInfo.vip_end_time) {
      autoModalFlag.value = true
    }
 
})
const allSelect = () => {
  if (showCheck.value && checkIds.value.length < paperList.value.length) {
    paperList.value.forEach(item => {
      checkIds.value.push(item.user_paper_detail_id)
      questionIds.value.push(item.question_id)
    })

  } else {
    checkIds.value = []
    questionIds.value = []

  }
}
const getPaperList = async (id, keywords, subjectName, tagId) => {
  questionIds.value = []
  let params
  if (!sessionData.value) {
    params = {
      subject_id: id,
      keyword: keywords,
      question_type_id: tagId
    }
    if (id && subject_id.value != id) {
      subject_id.value = id
      myPage.value = 1
    }
    keyword.value = keywords
  } else {
    myPage.value = sessionData.value.myPage
    mySize.value = sessionData.value.mySize
    params = sessionData.value.form
    subject_id.value = params.subject_id
    if (params) {
      commonTopSearchRef.value.subject_id = params.subject_id
    }
    sessionData.value = ''
  }
  initData(myPage.value, mySize.value, params)
}

const initData = async (page, size, params) => {
  if (page) {
    myPage.value = page
  }
  if (size) {
    mySize.value = size
  }
  if (params) {
    form.value = params
  }
  setSessionData({ mySize: mySize.value, myPage: myPage.value, form: form.value })
  form.value.page = myPage.value
  form.value.limit = mySize.value
  const { data } = await getErrorList(form.value)
  paperList.value = Object.values(data.list)
  totalElement.value = data.count
}
const del1 = async (id) => {
   Modal.confirm({
      title: '提示',
      content: '确定删除错题？',
      async onOk () {

  await delError({ user_paper_detail_id: id.toString() })
        message.success('删除成功')
        commonTopSearchRef.value.refresh()
        change()
      },
      onCancel () {
        change()
      },
    });
 
}

const del = async () => {
  if (checkIds.value.length == 0) {
    if (showCheck.value) {
      message.error('请先选择要删除的错题')
      return
    }

    change()
  } else {
    Modal.confirm({
      title: '提示',
      content: '确定从错题本移除选中题目？',
      async onOk () {
        await delError({ user_paper_detail_id: checkIds.value.join(',') })
        message.success('删除成功')
        commonTopSearchRef.value.refresh()
        change()
      },
      onCancel () {
        change()
      },
    });

  }
}
const exportError = async (exportType,radio) => {
  console.log('checkIds', checkIds.value.length)
  if (checkIds.value.length == 0) {
    // change()
  
    message.error('请先选择题目')
  } else {
    Modal.confirm({
      title: '提示',
       wrapClassName: 'custom-export-confirm-modal',
      content: '确定导出错题？',
      async onOk () {


        const data = await exportWrongPrint({ question_ids: questionIds.value, detail: exportType , is_other_question: radio })
        console.log('data', data)
        const a = document.createElement("a")
        a.href = window.URL.createObjectURL(data)
        a.download = `错题本.pdf`
        a.click()
        // commonTopSearchRef.value.refresh()
        change()
      },
      onCancel () {
        change()
      },
    });

  }
}



const change = () => {
  //固定
  showCheck.value = true
  checkIds.value = []
  questionIds.value = []
}

const toInfo1 = (row, str) => {
  router.push('/errorBook/errorInfo?type=1&id=' + row.user_paper_detail_id + '&subject_id=' + subject_id.value + '&has_favorite=' + row.has_favorite+'&question_favorite_id='+row.question_favorite_id)

}
const toInfo = (row, str) => {

  if (showCheck.value) {
    if (checkIds.value.indexOf(row.user_paper_detail_id) == -1) {
      checkIds.value.push(row.user_paper_detail_id)
      questionIds.value.push(row.question_id)

    } else {
      checkIds.value.splice(checkIds.value.indexOf(row.user_paper_detail_id), 1)
      questionIds.value.splice(questionIds.value.indexOf(row.question_id), 1)
    }
  } else if (str) {
    return
  }
  else {
    router.push('/errorBook/errorInfo?type=1&id=' + row.user_paper_detail_id + '&subject_id=' + subject_id.value)
  }
}
const toCollect = () => {
  router.push('/errorBook/collect')
}
let checkRef = ref()
const openDialog = () => {
  if (showCheck.value && checkIds.value.length > 0) {
    checkRef.value.dialogVisible = true
  } else {
    message.error('请先选择题目')
  }
  // console.log('520', checkIds)
  checkRef.value.subject_id = subject_id.value
  checkRef.value.getTypeList()

}
 
const wrongPaper = () => {
  if (  questionIds.value.length == 0) {
 
    message.error('请先选择题目')
    return
  }
   let form = {
   question_ids: questionIds.value,
    subject_id: subject_id.value
  }
  router.push('/doPaper?isWrong=1' + '&form=' + JSON.stringify(form))

}
  

let searchRef = ref()
const showSearch = () => {
  console.log('52088', searchRef)
  searchRef.value.subject_id = subject_id.value
  searchRef.value.getTypeList()
  searchRef.value.dialogVisible = true
}

</script>

<style lang="scss" scoped>
::v-deep .subjectabs{
width: 1520rem;
margin-left: 70rem;
}

.cuotiben_Warp {
  .autoModal { 
    position: fixed;
    left: 197 !important;
    top: 0;
    z-index: 9999;
    width: 90%;
    height: 100%;
    opacity: 1.5;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    );
    .btntext {
      position: fixed;
      left: 800rem;
      top: 700rem;
      .text {
        color: var(--light-333333, #333);
        text-align: center;

        font-size: 24rem;
        font-style: normal;
        font-weight: 600;
        line-height: 36rem; /* 150% */
      }
    }
    .openButton {
      ::v-deep .ant-btn {
        display: flex;
        width: 360rem;
        height: 64rem;
        justify-content: center;
        align-items: center;
        gap: 10rem;
        flex-shrink: 0;
        border-radius: 8rem;
        background: linear-gradient(100deg, #fdecc9 0%, #e9c383 100%);
        box-shadow: 0rem 8rem 16rem 0rem rgba(0, 0, 0, 0.1);
      }
    }
  }
  
  // position: relative;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100vh;
  // background-image: url("../../static/allBackg/bg-错题本.png"); 
  // background-color: #3e8ef3;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .topAll{
    display:flex;
    justify-content: space-between;
    align-items: center;
margin-left: 77rem;
width:1506rem;
  }
  .top {
    // position: absolute;
    margin-top: 40rem;
    right: 180rem;
       width:100rem;
    display: flex;
    justify-content: flex-end;
  }
  .top3 {
    // position: absolute;
    margin-top: 40rem;
        width:100rem;
    right: 459rem;
    padding: 6rem 24rem 8rem;
    line-height: 36rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-weight: 400;
    font-size: 24rem;
    border-radius: 120rem;
    background: #3e8ef3;
    cursor: pointer;
  }
  .top1 {
    // position: absolute;
    margin-top: 40rem;
       width:200rem;
    right: 1536rem;
    padding: 6rem 24rem 8rem;
    line-height: 36rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-weight: 400;
    font-size: 24rem;
    border-radius: 120rem;
    background: #3e8ef3;
    cursor: pointer;
  }
  .top2 {
    // position: absolute;
      width:200rem;
    margin-top: 40rem;
    right: 295rem;
    padding: 6rem 24rem 8rem;
    line-height: 36rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-weight: 400;
    font-size: 24rem;
    border-radius: 120rem;
    background: #3e8ef3;
    cursor: pointer;
  }
.its {
  overflow: hidden;
  color: var(--light-ffffff, #fff);
  text-overflow: ellipsis;
  font-size: 28rem;
  font-style: normal;
  font-weight: 400;
  margin-left:800rem;
margin-top: 250rem;
  line-height: 42px; /* 150% */
}
  .topic_warp {
    width: calc(100vw - 100rem);
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
    margin-top: 20rem;
    padding-left: 70rem;
    align-content: flex-start;
    max-height: calc(100vh - 338rem);
    gap:32rem;
    .topic_item_wrap {
      // margin: 20rem auto 0;
      padding: 0 10rem;
      width: 1518rem;
      // height: 290rem;
    }

    .topic {
      width: 100%;
      height: 100%;
      border-radius: var(--Radius-L, 28rem,);
 border:8rem solid #2FD7B8;
background: #FFF;
box-shadow: 0rem 2rem 8rem 0rem #2FD7B8;
      // background-image: url("../../static/cuotiben/card1.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      // margin-right: 30rem;
      padding: 16rem;
      position: relative;
      .checked {
        position: absolute;
        right: 17rem;
        top: 18rem;
        width: 20rem;
        height: 20rem;
        border-radius: 50%;
        border: 1rem solid #bbbbbb;
        img {
          width: 20rem;
          height: 20rem;
        }
      }
      div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .question_type {
        height: 36rem;
        width: 100%;
        line-height: 36rem;
        font-size: 24rem;
        font-weight: 500;
        color: #000000;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left;
        display: block;
        // margin-top: 30rem;
      }
      .comment,
      .pre_content {
        // margin: 0 20rem;
        display: flex;
        font-weight: 500;
        font-size: 20rem;
        margin-top: 10rem;
        font-weight: 400;
        line-height: 30rem;
        align-items: baseline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        flex: 1;
        color: #666666;
        span {
          padding-right: 5rem;
        }
      }
      .comment {
        height: 30rem;
        -webkit-line-clamp: 1;
      }
      .pre_content {
        margin-bottom: 8rem;

        // height: 60rem;
        -webkit-line-clamp: 4;
      }
      .btn {
        width: fit-content;
        // height: 44rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20rem;
        font-weight: 400;
        color: #ffffff;
        background: #ff654e;
        border-radius: 60rem;
        margin: 18rem auto 8rem;
        padding: 9rem 32rem;
        line-height: 30rem;
        cursor: pointer;
      }
      .time {
        font-weight: 400;
        font-size: 16rem;
        margin-top:8rem;
        color: #999999;
      }
    }
  }
}

.del {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-weight: 400;
  font-size: 24rem;
  border-radius: 35rem;
  padding: 6rem 24rem 8rem;
  line-height: 36rem;
  background: #3e8ef3;
  cursor: pointer;
}
.active {
  color: white;
  font-weight: bold;
}
:deep .ant-pagination-total-text {
  color: #fff;
}
:deep .ant-pagination-options-quick-jumper {
  color: #fff;
}
</style>
<style>
/* 这段样式是全局的，但类名带前缀，不会污染其他页面 */
.custom-export-confirm-modal .ant-modal {
 top:40vh;
}
</style>